import { Button, Result } from 'antd';
import React from 'react';
import { useNavigate } from 'react-router-dom';

function NoAccessPage() {
  const navigate = useNavigate();

  return (
    <Result
      status="403"
      title="403"
      subTitle="У вас нету доступа к этой странице"
      extra={
        <Button onClick={() => navigate(-1)} type="primary">
          Назад
        </Button>
      }
    />
  );
}

export { NoAccessPage };
